module.exports = {
  selectLanguage: 'Selecciona el lenguaje',
}



// WEBPACK FOOTER //
// ./src/data/messages/es.js